import { ObjectStrings } from '@sv-support-sdk/shared-types/src/common/utils';

export const FILE_ICON_TYPES: ObjectStrings = {
  pdf: 'colored--32--pdf',
};
